import * as React from "react";
import { useCart } from "@montana/containers/cart";
import { Translate } from "@montana/shared/translate";
import { Price } from "@montana/shared/price";
import { Button, ButtonStyles } from "@montana/shared/button";
import { SvgIcon } from "@montana/shared/svg-icon";

export const Summary = () => {
    const {
        totalPrice,
        totalVatAmount,
        dispatchTime,
        totalPriceWithoutDiscount,
        discounts,
        removeVoucher,
    } = useCart();

    return (
        <div className={`summary display-body`}>
            <h3 className="cart__summary-title">
                <Translate value="cartPage.cartPageSummary" defaultValue="[Summary]" />
            </h3>
            <div className="cart__summary-row">
                <p><Translate value={(t): string => t.cartPage.cartPageSubTotal} defaultValue="[Subtotal]" /></p>
                <p className="cart__summary-text-right"><Price obj={totalPriceWithoutDiscount} /></p>
            </div>
            {!!discounts?.length && discounts.map((discount, index) => (
                <div key={index} className="cart__summary-row cart__summary-voucher">
                    <div className="cart__summary-voucher-label">
                        {discount.percentage > 0 ? `${discount.discountName} (${discount.percentage}%)` : `${discount.discountName}`}
                        {discount.couponCode &&
                            <Button
                                className="cart__summary-voucher__remove"
                                disableStroke={true}
                                style={ButtonStyles.Text}
                                onClick={() => removeVoucher(discount.couponCode!)}
                            >
                                <SvgIcon iconName="close" />
                            </Button>
                        }
                    </div>
                    <p className="cart__summary-text-right">-&nbsp;<Price obj={discount.savedAmount} /></p>
                </div>
            ))}
            {!!dispatchTime && (
                <div className="cart__summary-row">
                    <p><Translate value={(t): string => t.cartPage.cartPageEstimatedDelivery} defaultValue="[Estimated delivery]" /></p>
                    <p className="cart__summary-text-right">{dispatchTime}</p>
                </div>
            )}
            {!!totalPrice &&
                <>
                    <hr className="cart__summary-hr border--extra-light" />
                    <div className="cart__summary-total-row">
                        <p className="cart__summary-total-label display-5">
                            <Translate value="cartPage.cartPageTotal" defaultValue="[Total]" />
                        </p>
                        <p className="cart__summary-total-price display-5"><Price obj={totalPrice} /></p>
                    </div>
                    <p className="cart__summary-including-eu-tax">
                        <Translate value="cartPage.euTaxIncluded" defaultValue="[Including EU tax:]" />
                        &nbsp;
                        <Price obj={totalVatAmount} />
                    </p>
                    <p className="cart__summary-suggested-retail-price"><Translate value="general.suggestedRetailPrice" defaultValue="[Suggested retail price]" /></p>
                </>
            }

        </div>
    );
};
